import { useState, useEffect, useRef } from 'react';

const useCamera = () => {
  const [stream, setStream] = useState(null);
  const [error, setError] = useState(null);
  const [isCameraReady, setIsCameraReady] = useState(false);
  const streamRef = useRef(null);

  useEffect(() => {
    let active = true;
    const getStream = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });
        if (active) {
          streamRef.current = mediaStream;
          setStream(mediaStream);
        } else {
          mediaStream.getTracks().forEach(track => track.stop());
        }
      } catch (err) {
        if (active) {
          console.error("Error accessing camera:", err);
          setError("Camera not available or access denied. Please try uploading a file instead.");
        }
      }
    };

    getStream();

    return () => {
      active = false;
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, []);

  const setVideoElement = (videoElement) => {
    if (videoElement && stream) {
      videoElement.srcObject = stream;
      videoElement.oncanplay = () => {
        setIsCameraReady(true);
      };
    }
  };

  return { stream, error, isCameraReady, setVideoElement };
};

export default useCamera;